import React from "react";
import { useSelector } from "react-redux";
import HelmetWrapper from "../../HelmetWrapper";
import LiveRenewalStructure from "../../components/live-subscriptions/live-renewal-reminder/LiveRenewalStructure";
import { selectUser } from "../../components/auth/auth.selector";

const LiveRenewalReminder = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Live Renewal Reminder">
      <LiveRenewalStructure userInfoData={userInfoData} />
    </HelmetWrapper>
  );
};

export default LiveRenewalReminder;
